var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    staticClass: "purchase-method-noti"
  }, [_c('v-card-title', [_vm._v(" 결제 서비스 준비중 ")]), _c('v-card-text', {
    staticClass: "purchase-method-noti__info"
  }, [_c('p', [_vm._v("해당 결제서비스는 준비중 입니다.")]), _c('p', [_vm._v("빠른 시일내에 서비스하겠습니다.")])]), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.exit
    }
  }, [_vm._v(" 닫기 ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }